import React from 'react'

export const getMousePosition = (e: React.MouseEvent | React.PointerEvent | React.TouchEvent): [number, number] => {
  const { clientX, clientY } = 'touches' in e ? e.touches[0] : e
  return [clientX, clientY]
}

export type MouseEventHandler = React.EventHandler<React.MouseEvent | React.PointerEvent | React.TouchEvent>

export const bindMouseDownEvents = (
  handler: MouseEventHandler
): {
  onMouseDown: MouseEventHandler
  onPointerDown: MouseEventHandler
  onTouchStart: MouseEventHandler
} => ({
  onMouseDown: handler,
  onPointerDown: handler,
  onTouchStart: handler
})

export const bindMouseMoveEvents = (
  handler: MouseEventHandler
): {
  onMouseMove: MouseEventHandler
  onPointerMove: MouseEventHandler
  onTouchMove: MouseEventHandler
} => ({
  onMouseMove: handler,
  onPointerMove: handler,
  onTouchMove: handler
})

export const bindMouseUpEvents = (
  handler: MouseEventHandler
): {
  onMouseUp: MouseEventHandler
  onPointerUp: MouseEventHandler
  onTouchEnd: MouseEventHandler
} => ({
  onMouseUp: handler,
  onPointerUp: handler,
  onTouchEnd: handler
})
